import { SecureLS } from './SecureLS';

export default SecureLS;
